<template>
  <EntityToAvatar
    :item="item"
    :schema="schema"
    :value="value"
    :size="40" />
</template>

<script>
import EntityToAvatar from '../Entity/EntityToAvatar'

export default {
  components: { EntityToAvatar },
  props: {
    value: {
      type: Object,
      default: null
    },
    item: {
      type: Object,
      required: false,
      default: null
    },
    schema: {
      type: Object,
      required: false,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
